import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpService } from './help.service';
import { HelpModel } from '../../../shared/help/help.model';

@Component({
    selector: 'convfact-adminhelp',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.css'],
    standalone: false
})
export class AdminHelpComponent implements OnInit {
  help = new HelpModel();
  errors = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helpService: HelpService
  ) {}

  submit(): void {}

  saveData = (help: HelpModel): void => {
    if (help.uid == null) {
      this.helpService.NewHelp(help)
        .then(result => {
          this.help = result;
          this.returnToIndex();
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    } else {
      this.helpService.editHelp(help.uid, help)
        .then(result => {
          this.help = result;
          this.returnToIndex();
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    }
  };

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const uid = params['uid'];
      if (uid != null) {
        this.helpService.GetHelp(uid).then(result => this.help = result);
      }
    });
  }

  returnToIndex = (): void => {
    this.router.navigate(['/admin/help']);
  };
}